import { Component, Input } from '@angular/core'

@Component({
  selector: 'dmmp-free-text',
  templateUrl: './free-text.component.html',
})
export class FreeTextComponent {
  @Input() data
  @Input() identifier
  @Input() detailLayout
}
